import Modal from "micromodal"

document.addEventListener("DOMContentLoaded", (e) => {
  Modal.init({
    openTrigger: "data-modal-open",
    closeTrigger: "data-modal-close",
    disableScroll: true,
    openClass: "modal-open",
    awaitOpenAnimation: true,
    awaitCloseAnimation: true
  })
})
